import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
// import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  toastSuccess,
  toastError,
} from "../../../../../customComponents/customToast/Toast";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import Loader from "../../../../../customComponents/CustomLoader";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import { showAlert } from "../../../../../customComponents/CustomSweetAlert/ShowAlert";
import { buttonStyle, isFormValid } from "../../../../../../helpers/common";
import validations from "../../../../../../helpers/validations";

const EditProduct = () => {
  const token = localStorage.getItem("authToken");
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const location = useLocation();
  const { data } = location.state || {};
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = data?.business_partner_id;
  const authToken = localStorage.getItem("authToken");
  const [userTypedd, setUserTypedd] = useState([]);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  useEffect(() => {
    fetchLeadPriorityEdit();
  }, []);

  const navigate = useNavigate();

  const fetchLeadPriorityEdit = async () => {
    try {
      const response = await axiosInstance.get(
        `/product/edit/${data?.product_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const fetchedData = response?.data?.data;

      setFormData({
        ...fetchedData,
        description: fetchedData?.product_desc,
        productimage: fetchedData?.product_image,
        status: fetchedData?.status === 1 ? true : false,
      });
      console.log("fetchedData", formData);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    CustomerInputs.forEach((field) => {
      if (field.validation) {
        if (field.name === "status" && formData.status === 0) {
        } else if (field.validation.required && !formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    setIsFormSubmitted(true);

    const payload = new FormData();
    payload.append("product_name", formData.product_name);
    payload.append("product_desc", formData.description);
    payload.append("status", formData.status === true ? 1 : 0);

    // if (formData.productimage) {
    //   payload.append("product_image", formData.productimage);
    // }

    payload.append(
      "product_image",
      formData.productimage ? formData.productimage : 0,
    );

    try {
      setLoading(true);
      const confirmation = await showAlert({
        title: "Confirmation",
        text: "Are you sure you want to update this record in Product?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      });

      if (!confirmation.isConfirmed) {
        setLoading(false);
        return;
      }

      const response = await axiosInstance.patch(
        `/product/update/${data.product_id}`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      console.log("API Response:", response.data);
      await showAlert({
        title: "Success",
        text: "Product updated successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });
      navigate(ROUTES_NAVIGATION.PRODUCTLIST);
    } catch (error) {
      console.error("Error updating product:", error);

      const errorMessage =
        error.response?.data?.message ||
        "Failed to update product. Please try again.";
      await showAlert({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  // const handleFormSubmit = async (formData) => {
  //   const errors = {};
  //   let isValid = true;

  //   console.log("formData", formData);

  //   // Form validation logic
  //   CustomerInputs.forEach((field) => {
  //     if (field.validation) {
  //       if (field.name === "status" && formData.status === 0) {
  //         // Specific validation logic for status field if needed
  //       } else if (field.validation.required && !formData[field.name]) {
  //         errors[field.name] = "This field is required";
  //         isValid = false;
  //       } else if (field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
  //         errors[field.name] = field.validation.message;
  //         isValid = false;
  //       }
  //     }
  //   });

  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     return;
  //   }

  //   setLoading(true); // Show loading state
  //   setIsFormSubmitted(true); // Set form submitted state

  //   // Payload creation
  //   const payload = {
  //     product_name: formData.product_name,
  //     product_desc: formData.product_desc,
  //     status: formData.status === 1 ? 1 : 0,
  //   };

  //   try {
  //     // Confirm with SweetAlert before submitting
  //     const confirmation = await showAlert({
  //       title: "Confirmation",
  //       text: "Are you sure you want to update this record in Product?",
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonText: "Yes",
  //       cancelButtonText: "Cancel",
  //     });

  //     // If the user cancels, exit early
  //     if (!confirmation.isConfirmed) {
  //       return;
  //     }

  //     // Perform API request
  //     const response = await axiosInstance.patch(
  //       `/product/update/${data.product_id}`,
  //       payload,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     console.log("API Response:", response.data);

  //     // Success alert after API response
  //     await showAlert({
  //       title: "Success",
  //       text: "Product updated successfully.",
  //       icon: "success",
  //       confirmButtonText: "OK",
  //     });

  //     // Navigate after success
  //     navigate(ROUTES_NAVIGATION.PRODUCTLIST);
  //   } catch (error) {
  //     console.error("Error updating product:", error);

  //     // Error alert in case of failure
  //     const errorMessage = error.response?.data?.message || "Failed to update product. Please try again.";
  //     await showAlert({
  //       title: "Error",
  //       text: errorMessage,
  //       icon: "error",
  //       confirmButtonText: "OK",
  //     });
  //   } finally {
  //     setLoading(false); // Hide loading state
  //   }
  // };

  const CustomerInputs = [
    {
      name: "product_name",
      label: "Name",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      placeholder: "Enter Product Name",
      validation: validations.productName({ required: true }),
      disabled: true,
    },
    {
      name: "description",
      label: "Description",
      placeholder: "Enter Product Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.description({ required: true }),
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",
      gridClass: "col-lg-4",
    },
    {
      name: "productimage",
      label: "Product Image",
      type: "file",
      // required: true,
      gridClass: "col-lg-6",
      allowedExtensions: ["jpg", "jpeg", "png", "pdf"],
      // validation: { required: true },
    },
  ];

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img
                src={backicon}
                alt="back"
                style={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}
              />
              <span className="backbtntitle">Edit Product</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Edit Product Details
              </span>
              <DynamicForm
                validateOnMount
                formConfig={CustomerInputs}
                formData={formData}
                setFormData={setFormData}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
                onSubmit={handleFormSubmit}
              />
            </div>
            <div className="btncontainer mt-3">
              <button
                className="submit-btn"
                disabled={
                  !isFormValid(CustomerInputs, formData, validationErrors) ||
                  loading
                }
                style={buttonStyle(
                  CustomerInputs,
                  formData,
                  validationErrors,
                  loading,
                )}
                onClick={() => handleFormSubmit(formData)}
              >
                {loading ? "Processing..." : "Submit"}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default EditProduct;
